import apiClient from "./client";
import type {
  DeleteDisasterParams,
  DisasterGetResponse,
  DisasterIdParam,
  DisasterMutationResponse,
  JoinDisasterPayload,
  SplitDisasterPayload,
  UpdateDisasterPayload,
} from "../types/disaster";

export const getDisaster = async (
  disasterId: DisasterIdParam
): Promise<DisasterGetResponse> => {
  const { data } = await apiClient.get<DisasterGetResponse>(
    `/disaster/${disasterId}`
  );
  return data;
};

export const updateDisaster = async (
  disasterId: DisasterIdParam,
  payload: UpdateDisasterPayload
): Promise<DisasterMutationResponse> => {
  const { data } = await apiClient.put<DisasterMutationResponse>(
    `/disaster/${disasterId}`,
    payload
  );
  return data;
};

export const deleteDisaster = async (
  disasterId: DisasterIdParam,
  params: DeleteDisasterParams
): Promise<DisasterMutationResponse> => {
  const { data } = await apiClient.delete<DisasterMutationResponse>(
    `/disaster/${disasterId}`,
    {
      params: {
        site_id: params.site_id,
      },
    }
  );
  return data;
};

export const joinDisaster = async (
  disasterId: DisasterIdParam,
  payload: JoinDisasterPayload
): Promise<DisasterMutationResponse> => {
  const { data } = await apiClient.put<DisasterMutationResponse>(
    `/disaster/${disasterId}/join`,
    payload
  );
  return data;
};

export const splitDisaster = async (
  disasterId: DisasterIdParam,
  payload: SplitDisasterPayload
): Promise<DisasterMutationResponse> => {
  const { data } = await apiClient.post<DisasterMutationResponse>(
    `/disaster/${disasterId}/split`,
    payload
  );
  return data;
};
